// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const houndstone: PokeData = {
  "id": 972,
  "name": "houndstone",
  "height": 20,
  "weight": 150,
  "base_experience": 171,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "double-edge",
    "tail-whip",
    "bite",
    "growl",
    "roar",
    "dig",
    "lick",
    "rest",
    "charm",
    "crunch",
    "helping-hand",
    "phantom-force",
    "play-rough",
    "last-respects"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "growl",
    "lick",
    "crunch",
    "phantom-force",
    "play-rough",
    "soul-sacrifice",
    "shadow-ball",
    "confuse-ray",
    "shadow-dagger",
    "curse"
  ],
  "evolution_chain": {
    "id": 509,
    "item": null,
    "species": [
      {
        "name": "greavard",
        "order": 924,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "houndstone",
        "order": 925,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 971,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 134,
    "speed": 107,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
